'use client';

import { cn } from '@/lib/utils';

/**
 * Currency with de-emphasised centavos — the restyle renders the cents smaller and in a
 * lighter tint of the value colour so the magnitude reads first. Splits on the pt-BR
 * decimal comma; masked/privacy values (no comma) render untouched.
 */
export function MoneyValue({ text, centsClassName }: Readonly<{ text: string; centsClassName?: string }>) {
  const comma = text.lastIndexOf(',');
  if (comma === -1) return <>{text}</>;
  return (
    <>
      {text.slice(0, comma)}
      <span className={cn('text-[0.6em] opacity-55', centsClassName)}>{text.slice(comma)}</span>
    </>
  );
}
